import { Wrapper } from "./style";

const CardBox = ({ children }: any) => (
  <Wrapper className="CardBox">
    {children}
  </Wrapper>
);

export default CardBox;